import React, { useState, useContext, useEffect }from 'react';
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonModal } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { useHistory } from 'react-router-dom';


//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../css/zPublic.css';


 export function Contact_Us(props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);
    let [modal_open, setModal_open] = useState(false);

    let history = useHistory();

    useEffect(() => {

        setModal_open(true);

    })

    const goToHome = () => {
        history.push('/home');
        window.location.reload();
      };

    return (
            <React.Fragment>
                <IonModal isOpen={ modal_open }>
                    <IonHeader className='grid_checkInHeader'>
                        <h1> CONTACT US</h1>
                    </IonHeader>

                    <IonContent className='privacy_statement'>
                        <IonGrid> 
                            <IonRow >
                                <IonCol size='12'>
                                    <h2>PHONE (Helpdesk): </h2>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol >
                                    <p> 024 534 6569 </p>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='12'>
                                    <h2>EMAIL </h2>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol >
                                    <p>tkweifio@live.com</p>
                                </IonCol>
                            </IonRow>      
                        </IonGrid>
                    </IonContent>

                    <IonFooter class='appFooter'>
                        <IonButton onClick={() => goToHome()}>Close</IonButton>
                    </IonFooter>

                    </IonModal>
            </React.Fragment>

    );
};



export default Contact_Us;